import { apiClient } from "./api";
import { useParams } from "react-router";

type FollowEmailParam = {
  email: string;
  name: string;
  message: string;
  invitation_type: string;
  invitation_method: string;
  expiration_days: number;
};
type FollowNumberParam = {
  phone: string;
  phone_country_code: string;
  name: string;
  message: string;
  invitation_type: string;
  invitation_method: string;
  expiration_days: number;
};

export const sendFollowEmail = async (
  params: FollowEmailParam[]
): Promise<any> => {
  try {
    const response = await apiClient.post(
      "/api/v2/invitations/sendInvite",
      params
    );
    return response.data;
  } catch (error) {
    console.error("Error Sending Follow Email", error);
    throw error;
  }
};
export const sendFollowNumber = async (
  params: FollowNumberParam[]
): Promise<any> => {
  try {
    const response = await apiClient.post(
      "/api/v2/invitations/sendInvite",
      params
    );
    return response.data;
  } catch (error) {
    console.error("Error Sending Follow Email", error);
    throw error;
  }
};
export const sendInvite = async (params: any): Promise<any> => {
  try {
    const response = await apiClient.post(
      "/api/v2/invitations/sendInvite",
      params
    );
    return response.data;
  } catch (error) {
    console.error("Error Sending Follow Email", error);
    throw error;
  }
};

export const decodeInvitationToken = async (invitation_token: string) => {
  try {
    const getStoredToken = await apiClient.post("/api/invitationdetails", {
      invitation_token: invitation_token,
    });
    return getStoredToken;
  } catch (error: unknown) {
    console.error("Error decoding invitation token:", error);
    return {
      isValid: false,
      error: error instanceof Error ? error.message : String(error),
    };
  }
};